<template>
    <div>
        <MainPage customClass="show-bottom-shoping-cart lg:max-w-5xl" @clickBack="clickBack()">
            <div v-if="isLoginShoppingCart" class="px-4">
                <div v-show="isLoaded && !isOrderEmpty">
                    <CartStatus></CartStatus>
                    <CartAddress
                        ref="cart-address"
                        @onLoaded="onLoadSuccess('cartAddress')"
                        @gotoDeliveryMethod="gotoDeliveryMethod()"
                    ></CartAddress>
                    <div class="grid lg:grid-cols-2 lg:gap-20 lg:px-6 lg:pt-4 lg:border lg:border-a-brown-d7c7b8 lg:rounded-20 lg:mt-6">
                        <div>
                            <CartOrder
                                ref="cart-order"
                                @updateItem="onUpdateItem()"
                                @orderempty="onUpdateOrderEmpty()"
                                @onLoaded="onLoadSuccess('cartOrder')"
                                @onReLoadSuccess="onReLoadSuccess()"
                                @clickAddmore="clickGotoHome()"
                            ></CartOrder>
                        </div>
                        <div>
                            <CartSummary ref="cart-summary"></CartSummary>
                            <CartCoupon
                                @gotoCoupon="gotoCoupon()"
                            ></CartCoupon>
                            <CartAdditional></CartAdditional>
                            <div class="absolute lg:relative bottom-0 left-0 w-full bg-a-egg-f5ebdc border-t border-a lg:border-0 shadow-top lg:shadow-none px-4 py-3 lg:py-6">
                                <div class="text-center text-a-brown-502314 font-bold">{{getTotal()}}</div>
                                <div class="flex py-3">
                                    <img class=" mr-0 ml-auto my-auto" src="@/assets/icon/ic-reward-green.svg" />
                                    <div class="text-a-green-198737 ml-1 mr-auto my-auto text-14">{{getPoint()}}</div>
                                </div>
                                <RedButton @click="clickCheckout()">
                                    {{lbl.shoppingcart.checkout}}
                                </RedButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-empty-screen flex" v-if="isLoaded && isOrderEmpty">
                    <div class="m-auto w-full px-4">
                        <div class="flex w-full pb-1">
                            <img class="m-auto" src="@/assets/icon/ic-bag-empty-brown.svg" />
                        </div>
                        <div class="text-14  text-a-brown-9f8273 text-center pb-4">No cart item found</div>
                        <div class="flex w-full">
                            <RedButton customClass="w-64 py-2.5 m-auto" @click="clickGotoHome()">
                                Order Now!
                            </RedButton>
                        </div>
                    </div>
                </div>
            </div>
        </MainPage>
    </div>
</template>

<script>

//helper
import Util from '@/helper/Utility.js';
import Account from '@/helper/AccountHelper.js';
import CacheHelper from "@/helper/CacheHelper";
import Locale from "@/helper/locale/Locale.js";
import CartHelper from '@/helper/CartHelper';
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import CartStatus from "../component/CartStatus.vue";
import CartAddress from "../component/CartAddress.vue";
import CartOrder from "../component/CartOrder.vue";
import CartCoupon from "../component/CartCoupon.vue";
import CartAdditional from "../component/CartAdditional.vue";
import CartSummary from "../component/CartSummary.vue";
import RedButton from "@/components/Button/RedButton.vue";
//model
import { SaveCartModel } from '../model/SaveCartModel';
import { AddCartModel } from '@/core/Cart/model/CartModel.js';
//service
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import BKCart from '../service/BKCart.js';
//Mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import CookieMixin from '@/mixin/CookieMixin';
export default {
    name: "OrderSummary",
    inject: ['PlaceOrderStore','ShippingStore','DeliveryStore','CartCountStore'],
    mixins: [LocaleMixin,AuthStatusMixin,ModalMixin,CookieMixin],
    components: {
        MainPage,
        CartStatus,
        CartAddress,
        CartOrder,
        CartCoupon,
        CartAdditional,
        CartSummary,
        RedButton
    },
    data: function() {
        return {
            KEY_SESSION_CONNECTION: 'connect_err',

            isLoginShoppingCart: false,
            isLoaded: false,
            isOrderEmpty: false,

            cartUpsale: [],

            loadingStatus: {
                cartAddress: false,
                cartOrder: false,
            },
            isLoadedDeliveryFee: false,
            isErrorLoading: false,

            addCartModel: new AddCartModel(),
            interval: null,

            isDisableGoExternal: false,
        }
    },
    created: function() {
        this.tracking.screenName('shopping_bag');
        // this.tracking.event('shopping_bag','view_shopping_bag', null, null);
    },
    mounted: function() {
        this.modal.loadingModal.show();
    },
    beforeUnmount: function() {
        this.modal.alertModal.hide();
    },
    methods: {
        onAccountInit: function() {
            console.log("Account Init");
            this.ShippingStore.methods.init();
            this.PlaceOrderStore.methods.init();
            this.initLogin();

        },
        initLogin: async function () {
            var return_url = this.$route.query.return_url;
            if (return_url) {
                CartHelper.setCacheReturnUrl(return_url);
            }

            var jwt = this.$route.query.jwt;
            if (jwt && jwt != '') {
                // token = Util.reShuffleToken(token);
                //var isLogin = await this.apiLogin(token);

                if (await this.apiLogin(jwt)) {
                    if (this.localeCode != Locale.getLocaleCode()) {
                         window.location.reload();
                    } else {
                        this.apiUpdateProfile();
                        this.DeliveryStore.methods.getDelivery();

                        this.isLoginShoppingCart = true;
                        this.acceptCookie();
                    }

                }
                else {
                    Account.removeCacheUser();
                    this.modal.loadingModal.hide();
                }
            } else {
                this.onLoadSuccess('cartAddress')
                //this.DeliveryStore.methods.getDelivery();
                this.isLoginShoppingCart = true;
            }

        },
        
        clickBack: function() {
            // if (!this.isLoadedDeliveryFee) return;

            if (this.isLoadedDeliveryFee || this.isErrorLoading) {
                if (this.isDisableGoExternal)
                    return;
                else
                    this.isDisableGoExternal = true;

                let cacheReturnUrl = CartHelper.getCacheReturnUrl();
                this.PlaceOrderStore.methods.removePlaceOrder();
                this.ShippingStore.methods.removeShipping();
                if (cacheReturnUrl) {
                    window.location.href = cacheReturnUrl;
                } else {
                    this.$router.back();
                }
            }
        },
        clickGotoHome: function() {
            // if (!this.isLoadedDeliveryFee) return;
            if (this.isLoadedDeliveryFee || this.isErrorLoading) {
                if (this.isDisableGoExternal)
                    return;
                else
                    this.isDisableGoExternal = true;


                let cacheReturnUrl = CartHelper.getCacheReturnUrl();
                this.PlaceOrderStore.methods.removePlaceOrder();
                this.ShippingStore.methods.removeShipping();
                if (cacheReturnUrl) {
                    cacheReturnUrl += "home";
                    window.location.href = cacheReturnUrl;
                } else {
                    this.$router.push("/home");
                }
            }

            
        },
        clickCheckout: async function() {
            console.log("clickCheckout",this.isLoadedDeliveryFee);
            if (!this.isLoadedDeliveryFee) return;
            let delivery = this.$refs['cart-address'].getData();
            if (delivery.limitOrder) {
                this.modal.alertModal
                    .clearModal()
                    .setMsg(this.lbl.shoppingcart.popup_limit_order.msg)
                    .setBtnOk(this.lbl.shoppingcart.popup_limit_order.btn_close)
                    .show();
            } else {
                this.modal.loadingModal.show();
                this.PlaceOrderStore.methods.updatePlaceOrder();

                this.trackingCheckout();

                if (await this.apiGetCartUpsale()) {
                    if (this.cartUpsale.length == 0) {
                        this.saveCart();
                    } else {
                        this.saveCart(()=> {
                            this.showUpsale();
                        });

                    }
                }
            }

            
        },
        trackingCheckout: function() {
            let cartList = this.$refs['cart-order'].getData();
            let label = '';
            let labelCampaignId = '';
            let labelCampaignName = '';
            let labelQuantity = '';

            label = 'shopping_bag|';
            for (let cartitem of cartList) {
                labelCampaignId += cartitem.campaignId + '_';
                labelCampaignName += this.localeCode == 1033 ? cartitem.nameEng : cartitem.name + '_';
                labelQuantity += cartitem.quantity  + '_';
            }
            label += labelCampaignId.substring(0,labelCampaignId.length - 1) + '|';
            label += labelCampaignName.substring(0,labelCampaignName.length - 1) + '|';
            label += labelQuantity.substring(0,labelQuantity.length - 1) + '|';
            if (this.PlaceOrderStore.state.placeOrder.coupon) {
                if (this.PlaceOrderStore.state.placeOrder.coupon.id) {
                    label += this.PlaceOrderStore.state.placeOrder.coupon.id + '|';
                    label += this.PlaceOrderStore.state.placeOrder.coupon.name;
                } else {
                    label += this.PlaceOrderStore.state.placeOrder.coupon.code + '|';
                }

            }
            this.tracking.event('shopping_bag','click_checkout', label, null);
        },
        showUpsale: function() {
            this.modal.loadingModal.hide();
            this.modal.upsaleModal.clearModal()
                                .setCampaignList(this.cartUpsale)
                                .setBtnOk(this.lbl.shoppingcart.popup_upsale.proceed_to_checkout)
                                .show();
            this.modal.upsaleModal.onClickOk(async (campaign)=> {
                this.cartUpsale = campaign;
                this.addCartModel = new AddCartModel()

                let label = '';
                let labelCampaignId = '';
                let labelCampaignName = '';
                let labelQuantity = '';

                for(campaign of this.cartUpsale) {
                    if (campaign.quantity && campaign.quantity > 0) {
                        this.addCartModel.addItem(campaign.id,campaign.quantity);

                        labelCampaignId += campaign.id + '_';
                        labelCampaignName += campaign.name + '_';
                        labelQuantity += campaign.quantity  + '_';
                    }
                }

                if (labelCampaignId != '') {
                    label = "recommend_menu|";
                    label += labelCampaignId.substring(0,labelCampaignId.length - 1) + '|';
                    label += labelCampaignName.substring(0,labelCampaignName.length - 1) + '|';
                    label += labelQuantity.substring(0,labelQuantity.length - 1) + '|';
                    this.tracking.event('shopping_bag','click_proceed', label, null);
                }

                this.modal.loadingModal.show();
                if (await this.apiAddCart()){
                    this.modal.loadingModal.hide();
                    this.$refs['cart-order'].reLoad();
                }
            });
        },
        saveCart: async function(callback,callbackfail) {
            let saveCartModel = new SaveCartModel();
            let cartList = this.$refs['cart-order'].getData();
            saveCartModel.cartList = cartList;
            saveCartModel.setDelivery(this.$refs['cart-address'].getData());

            let isSaveCartSuccess = await this.apiSaveCart(saveCartModel);
            if (isSaveCartSuccess) {
                this.CartCountStore.methods.updateCartCountFromCartItem(cartList);
                if (Util.isFunction(callback)) {
                    callback();
                } else {
                    this.$router.push("/orderpayment");
                }
            } else {
                if (Util.isFunction(callbackfail)) {
                    callbackfail();
                }
            }
        },
        apiAddCart: async function() {
            return new Promise((resolve) => {
                let params = this.addCartModel.getParams()
                BKCart.apiAddToCart(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiSaveCart: async function(saveCartModel) {
            return new Promise((resolve) => {
                let params = saveCartModel.getParams()
                BKCart.apiPostSaveCart(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        if (err.code == 409 && err.id == "1403") {
                            this.modal.errorModal
                                        .clearModal()
                                        .setMsg(this.lbl.shoppingcart.error_cart)
                                        .show();
                        } else {
                            this.errorApi(err);
                        }

                    },
                });
            });
        },
        apiLogin: async function(token) {
            return new Promise((resolve) => {
                BzbsAuth.apiReLoginDevice(token, null).subscribe({
                    next: (data) => {
                        Account.setLogin(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiGetCartUpsale: async function() {
            return new Promise((resolve) => {
                BzbsCart.apiGetCartUpsale().subscribe({
                    next: (data) => {
                        console.log(data);
                        if (data.length != 0) {
                            this.cartUpsale = data;
                        }
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiGetShippingPrice: async function() {
            return new Promise((resolve) => {
                let params = this.ShippingStore.state.shipping.getParams();
                console.log(params);
                BKCart.apiGetShippingPrice(params).subscribe({
                    next: (data) => {
                        if (data) {
                            this.ShippingStore.state.shipping.shippingPrice = data.Quotes[0].Price;
                        }

                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.isErrorLoading = true;
                        if (err.id == 1203) {
                            this.checkErrorConnection();
                        } else {
                            this.errorApi(err);
                        }

                    },
                });
            });
        },
        apiGetCartConfig: function() {
            return new Promise((resolve) => {
                BKCart.apiGetCartConfig().subscribe({
                    next: (data) => {
                        if (data.delivery_contactnumber) {
                            this.ShippingStore.state.shipping.startContactNumber = data.delivery_contactnumber;
                        }
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.isErrorLoading = true;
                        this.errorApi(err);
                    },
                });
            });
        },
        setupShippingConfig: async function(callback) {
            this.modal.loadingModal.show();
            if (await this.apiGetCartConfig()) {
                let delivery = this.$refs['cart-address'].getData();
                if (delivery.limitOrder) {
                    this.modal.alertModal
                        .clearModal()
                        .setMsg(this.lbl.shoppingcart.popup_limit_order.msg)
                        .setBtnOk(this.lbl.shoppingcart.popup_limit_order.btn_close)
                        .show();
                }
                if (delivery.deliveryMethod == "Delivery" && delivery.address) {
                    
                    this.ShippingStore.state.shipping.setDelivery(delivery);
                    if (delivery.deliverTime) {
                        this.ShippingStore.state.shipping.setDeliveryTime(delivery.deliverTime);
                    } else {
                        this.ShippingStore.state.shipping.setDeliveryTime('');
                    }
                    this.ShippingStore.state.shipping.setProfile(this.profile);
                    this.ShippingStore.state.shipping.setPackages(this.$refs['cart-order'].getData());
                    if (this.PlaceOrderStore.state.placeOrder.coupon) {
                        if (this.PlaceOrderStore.state.placeOrder.coupon.codeType == "user") {
                            this.ShippingStore.state.shipping.setDiscount(this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit);
                            this.ShippingStore.state.shipping.setShippingDiscount(0);
                        } else {
                            this.ShippingStore.state.shipping.setDiscount(0);
                            this.ShippingStore.state.shipping.setShippingDiscount(this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit);
                        }
                    } else {
                        this.ShippingStore.state.shipping.setDiscount(0);
                        this.ShippingStore.state.shipping.setShippingDiscount(0);
                    }

                    if (await this.apiGetShippingPrice()) {
                        this.ShippingStore.methods.updateShipping();
                        if (this.$refs['cart-order']) {
                            this.$refs['cart-order'].calSummery();
                        }

                        this.$refs['cart-summary'].updateDeliveryFee();

                        this.saveCart(()=> {
                            this.isLoadedDeliveryFee = true;
                            this.modal.loadingModal.hide();
                            if (Util.isFunction(callback)) {
                                callback();
                            }   
                        },()=> {
                            this.isLoadedDeliveryFee = true;
                        })
                    }
                    // } else {
                    //     this.isLoadedDeliveryFee = true;
                    // }

                } else {
                    this.ShippingStore.state.shipping.shippingPrice = 0;
                    this.ShippingStore.methods.updateShipping();
                    //this.$refs['cart-order'].calSummery();
                    if (this.$refs['cart-order']) {
                        this.$refs['cart-order'].calSummery();
                    }
                    this.$refs['cart-summary'].updateDeliveryFee();
                    this.saveCart(()=> {
                        this.isLoadedDeliveryFee = true;
                        if (Util.isFunction(callback)) {
                            callback();
                        } 
                    },()=> {
                        this.isLoadedDeliveryFee = true;
                    });
                }

            }
        },
        onUpdateItem: function() {
            this.isLoadedDeliveryFee = false;
            this.$refs['cart-summary'].processDeliveryFee();
            if (this.interval) {
                clearInterval(this.interval);
            }

            this.interval = setInterval(() => {
                clearInterval(this.interval);
                this.setupShippingConfig();
            }, 3000);
        },
        onUpdateOrderEmpty: function () {
            this.isOrderEmpty = true;

            this.intervalGotoHome = setInterval(() => {
                if (this.isLoadedDeliveryFee) {
                    clearInterval(this.intervalGotoHome);
                    this.clickGotoHome();
                }
            }, 1000);
        },
        onReLoadSuccess: function () {
            this.setupShippingConfig(()=>{
                this.modal.loadingModal.show();
                this.saveCart();
            });
        },
        onLoadSuccess: function(api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    //this.modal.loadingModal.hide();
                    this.isLoaded = true;
                    this.setupShippingConfig();
                }
            }

            if (api == 'cartOrder') {
                let cartList = this.$refs['cart-order'].getData();

                let label = '';
                for (let cartitem of cartList) {
                    label = 'shopping_bag|' + cartitem.campaignId + '|';
                    label += this.localeCode == 1033 ? cartitem.nameEng : cartitem.name;
                    this.tracking.event('shopping_bag','view_shopping_bag', label, null);
                }

            }
        },
        gotoDeliveryMethod: function () {
            if (!this.isLoadedDeliveryFee) return;
            this.tracking.event('shopping_bag','click_edit_mode', null, null);
            this.$router.push("/deliverymethod");
        },

        gotoCoupon: function () {
            if (!this.isLoadedDeliveryFee) return;

            this.$router.push("/coupon");
        },
        getPoint: function() {
            let sum = 0;
            if (this.PlaceOrderStore.state.placeOrder.coupon) {
                if (this.PlaceOrderStore.state.placeOrder.coupon.codeType == "user") {
                    sum = this.PlaceOrderStore.state.placeOrder.subtotal - this.PlaceOrderStore.state.placeOrder.coupon.pricePerUnit;
                } else {
                    sum = this.PlaceOrderStore.state.placeOrder.subtotal;
                }
            } else {
                sum = this.PlaceOrderStore.state.placeOrder.subtotal;
            }

            if (sum > 0) {
                sum = sum / 25;
            } else {
                sum = 0;
            }

            //return Math.floor(sum);
            return Util.stringFormat(this.lbl.shoppingcart.you_will_get_points,this.FilterNumberFormat(Math.floor(sum)))
        },
        getTotal: function() {
            return Util.stringFormat(this.lbl.shoppingcart.total_bath,this.FilterNumberFormat(this.PlaceOrderStore.state.placeOrder.total))
        },
        checkErrorConnection: function() {
            let cacheSession = new CacheHelper("session");
            let connectionErr = cacheSession.getCache(this.KEY_SESSION_CONNECTION);
            if (!connectionErr) {
                this.modal.confirmTwoButtonModal
                                    .clearModal()
                                    .setMsg(this.lbl.shoppingcart.popup_connection_error.msg)
                                    .setBtnOk(this.lbl.shoppingcart.popup_connection_error.retry)
                                    .setBtnCancel(this.lbl.shoppingcart.popup_connection_error.cancel)
                                    .show();
                        this.modal.confirmTwoButtonModal.onClickOk(() => {
                            connectionErr = 1;
                            cacheSession.setCache(this.KEY_SESSION_CONNECTION,connectionErr)
                            window.location.reload();
                        })
            } else if (connectionErr && connectionErr < 3) {
                connectionErr = connectionErr + 1;
                cacheSession.setCache(this.KEY_SESSION_CONNECTION,connectionErr)
                this.modal.confirmTwoButtonModal
                                    .clearModal()
                                    .setMsg(this.lbl.shoppingcart.popup_connection_error.msg)
                                    .setBtnOk(this.lbl.shoppingcart.popup_connection_error.retry)
                                    .setBtnCancel(this.lbl.shoppingcart.popup_connection_error.cancel)
                                    .show();
                        this.modal.confirmTwoButtonModal.onClickOk(() => {
                            window.location.reload();
                        })
            } else {
                this.modal.alertModal
                            .clearModal()
                            .setMsg(this.lbl.shoppingcart.popup_contact_bk.msg)
                            .setBtnOk(this.lbl.shoppingcart.popup_contact_bk.confirm)
                            .show();
                this.modal.alertModal.onClickOk(() => {
                    this.clickGotoHome();
                })
            }
        }

    }
}
</script>

<style lang="scss" scoped>
    .order-empty-screen {
        height: calc(100vh - 59px);
    }
</style>
